import { Component, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-crypt-form',
  templateUrl: './crypt-form.component.html',
  styleUrls: ['./crypt-form.component.css']
})
export class CryptFormComponent implements OnInit {

  @ViewChild('file') input;
  public files: Array<File> = [];

  constructor() { }

  ngOnInit() { }
  ngOnDestroy() { }

  onFileChange() {
    for(var i = 0; i < this.input.nativeElement.files.length; i++) {
      this.files.push(this.input.nativeElement.files[i]);
    }
  }

  onDeleteFile(file) {
    let index = this.files.indexOf(file);

    if (index >= 0) {
      this.files.splice(index, 1);
    }
  }
}
